import React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { LogicTreePageQuery$data } from "./__generated__/LogicTreePageQuery.graphql";
import { Button, Container, Typography, styled } from "@mui/material";
import { Link } from "react-router-dom";
import { viewPath } from "../../utils/routeUtils";

export interface SourceBranchesTableProps {
  data: LogicTreePageQuery$data;
}
export interface DataGridTitleProps {
  title: string;
}

export const TabContainer = styled(Container)(() => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "left",
}));

export const SourceBranchesTab = ({ data }: SourceBranchesTableProps) => {
  return (
    <TabContainer>
      <Typography variant="h5" gutterBottom>
        Source Branches for: {data?.get_model?.version}
      </Typography>
      <SourceBranchesTable data={data} />
    </TabContainer>
  );
};

export const SourceBranchesTable: React.FC<SourceBranchesTableProps> = ({ data }: SourceBranchesTableProps) => {
  const columns: GridColDef[] = [
    { field: "tag", headerName: "Tag", width: 400, renderHeader: () => <strong>Tag</strong> },
    { field: "weight", headerName: "Weight", width: 150, renderHeader: () => <strong>Weight</strong> },
    {
      field: "inversion_source_id",
      headerName: "Inversion Source",
      renderHeader: () => <strong>Inversion Source</strong>,
      width: 180,
      sortable: false,
      renderCell: (params) =>
        params.value && (
          <Button component={Link} to={viewPath(params.value)}>
            More
          </Button>
        ),
    },
    {
      field: "inversion_nrml_id",
      headerName: "Inversion NRML",
      renderHeader: () => <strong>Inversion NRML</strong>,
      width: 180,
      sortable: false,
      renderCell: (params) =>
        params.value && (
          <Button component={Link} to={viewPath(params.value)}>
            More
          </Button>
        ),
    },
    {
      field: "distributed_nrml_id",
      headerName: "Distributed NRML",
      renderHeader: () => <strong>Distributed NRML</strong>,
      width: 180,
      sortable: false,
      renderCell: (params) =>
        params.value && (
          <Button component={Link} to={viewPath(params.value)}>
            More
          </Button>
        ),
    },
  ];

  const branches = data?.get_model?.source_logic_tree?.branch_sets?.map((branch) => {
    return branch;
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getRows = (branch: { branches: any }) => {
    return branch.branches.length > 1
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        branch?.branches?.map((branch: any, i: number) => {
          const row = {
            id: i,
            tag: branch?.tag,
            weight: branch?.weight.toFixed(4),
            inversion_source_id: branch?.sources?.[0]?.inversion_id,
            inversion_nrml_id: branch?.sources?.[0]?.nrml_id,
            distributed_nrml_id: branch?.sources?.[1]?.nrml_id,
          };
          return row;
        })
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        branch?.branches?.map((branch: any, i: number) => {
          const row = {
            id: i,
            tag: branch?.tag,
            weight: branch?.weight.toFixed(4),
            inversion_source_id: "",
            inversion_nrml_id: "",
            distributed_nrml_id: branch?.sources?.[0]?.nrml_id,
          };
          return row;
        });
  };

  return (
    <Box sx={{ minHeight: 400, width: "100%" }}>
      {branches
        ? branches.map((branch, i) => (
            <Box key={i}>
              <Box style={{ width: "100%", display: "flex", margin: "20px" }}>
                <Typography variant="h5">{branch?.long_name}</Typography>
              </Box>
              <DataGrid
                sx={{ overflowX: "scroll" }}
                autoHeight
                hideFooter
                rows={branch ? getRows(branch) : []}
                columns={columns}
              />
            </Box>
          ))
        : "No data"}
    </Box>
  );
};
